import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const slides = [
  {
    image: "1.jpg", // Замените на реальные пути к изображениям
    title: "DRONE SHOWS",
    text: "Enjoy the drone shows that will light up the sky of Al Wathba! From the festival opening to Eid Al Etihad festival and New Years Eve, don't miss these amazing displays!",
  },
  {
    image: "2.jpg",
    title: "Emirates Fountain and Laser Shows",
    text: "Emirates Fountain will showcase modern shows that combine huge screens, laser light effects, and holograms to create stunning artistic performances",
  },
  {
    image: "3.jpg",
    title: "Heritage Village - The Past Through Today’s Eyes",
    text: "The Heritage Village offers you the chance to explore the rich heritage and culture of the United Arab Emirates, filled with authentic customs and traditions. Enjoy a unique atmosphere with various events, traditional markets, handicrafts, and folkloric performances",
  },
  {
    image: "4.jpg",
    title: "Fireworks Shows",
    text: "One of the festival's signature events is the Sheikh Zayed Festival's impressive fireworks display, which sets a record each year in the Guinness World Records. These displays use the latest technology to create synchronized and artistic pyrotechnic shows set to music, providing visitors with an unforgettable experience.",
  },
];

export default function Slider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const navigate = useNavigate()

  return (
    <div className="relative  w-full h-screen overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentIndex ? "opacity-100" : "opacity-0"
          }`}
          style={{ backgroundImage: `url(${slide.image})`, backgroundSize: "cover", backgroundPosition: "center" }}
        >
          <div className="absolute md:px-24 inset-0 flex flex-col items-start justify-center p-10 cus-grad">
            <h2 className="text-4xl font-bold max-w-[800px] text-white">{slide.title}</h2>
            <p className="mt-6 text-xl  max-w-[800px] text-white">{slide.text}</p>
          </div> 
          
        </div>
      ))}
    </div>
  );
}